import React, { useMemo } from "react";
import { createContext, useContext } from "react";
import { useRecoilValue } from "recoil";
import { organisationIdState } from "../atoms";
import { useOrganisationsQuery, useOrganisationPermissionsQuery } from "../queries";
import { find } from "lodash";
import { useUserContext } from "./useUserContext";

const OrganisationContext = createContext({
  organisations: null,
  organisationsQuery: null,
  selectedOrganisation: null,
});

export const useOrganisationContext = () => useContext(OrganisationContext);

export const OrganisationContextProvider = ({ children }) => {
  const organisationId = useRecoilValue(organisationIdState);
  const { isUser } = useUserContext();

  const organisationsQuery = useOrganisationsQuery({
    enabled: isUser,
  });
  const { data: organisations } = organisationsQuery;

  const selectedOrganisation = useMemo(() => {
    return find(organisations, { id: organisationId });
  }, [organisations, organisationId]);

  if (organisationsQuery.isLoading) return null;

  return (
    <OrganisationContext.Provider
      value={{
        organisations: organisations,
        organisationsQuery,
        selectedOrganisation,
      }}
    >
      {children}
    </OrganisationContext.Provider>
  );
};
